import { Fragment, FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { CirclePlayPauseButton } from '../../circlePlayPauseButton/circlePlayPauseButton';
import { FullscreenButton } from '../../controlsBar/fullScreenButton/fullScreenButton';
import { playerDataSelector } from '../../../../common/store/selectors/playerData.selector';
import { SeekBarContainer } from '../../seekBar/seekBarContainer';
import { Volume } from '../../controlsBar/volume/volume';
import { isDesktopMode } from '../../../../common/utils/utils';
import { getPartialControlsContainer } from '../../htmlElements/htmlElementsIdGetter';
import { brandingDataSelector } from '../../../../common/store/selectors/brandingData.selector';
import { ExtraSmallControls } from './extraSmallControls/extraSmallControls';

interface PartialVideoControlsComponentVariablesProps {
  clickToPlayMode: boolean;
}

const getButtonsWrapperStyle = (smallMobileMode: boolean) => ({
  position: 'absolute',
  margin: smallMobileMode ? '0px' : '6px 0px 0px 6px',
  display: 'flex',
});

export const PartialVideoControls: FunctionComponent<PartialVideoControlsComponentVariablesProps> = props => {
  const { clickToPlayMode } = props;

  const playerMode = useSelector(playerDataSelector.playerMode);
  const playerSize = useSelector(playerDataSelector.playerSize);
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqId);
  const controlsDisplay = useSelector(brandingDataSelector.controlsDisplay);

  const viewDisplay = controlsDisplay === 'viewDisplay';
  const desktopMode = isDesktopMode(playerMode);
  const mediumOrSmallSize = playerSize === 'small' || playerSize === 'medium';
  const smallMobileMode = !desktopMode && mediumOrSmallSize;

  const buttonsWrapperStyle = getButtonsWrapperStyle(smallMobileMode);

  return playerSize === 'extraSmall'
    ? <ExtraSmallControls />
    : (
      <Fragment>
        <CirclePlayPauseButton />
        {!viewDisplay
        && (
          <div style={buttonsWrapperStyle} id={getPartialControlsContainer(playerUniqueId)}>
            <FullscreenButton outsideControlsBar />
            <Volume outsideControlsBar />
          </div>
        )}
        <SeekBarContainer clickToPlayMode={clickToPlayMode} />
      </Fragment>
    );
};
